import { createAction, props } from '@ngrx/store';
import { FileEntity } from './files.models';

export const addFile = createAction('[Files] Add File', props<{ file: FileEntity }>());
export const loadFiles = createAction('[Files] Load Files', props<{ conversationId: number }>());
export const loadFilesSuccess = createAction('[Files] Load Files Success', props<{ files: FileEntity[] }>());
export const loadFilesFailure = createAction('[Files] Load Files Failure', props<{ error: any }>());
